import { createResource } from 'react-resource-router';

import { fetchUiSettingsEndpoint } from '../endpoints';
import { type LogSettingsResponseType } from '../endpoints/types';

export const uiSettingsResource = createResource<LogSettingsResponseType>({
	type: 'ui-settings-resource',
	getKey: () => 'ui-settings-resource',
	getData: async () => fetchUiSettingsEndpoint(),
	maxAge: Infinity,
	isBrowserOnly: true,
});
